import { siteApiSlice } from "../../../../app/siteApiSlice";
import { MonthlyScoresFilteredByWriterViewModel } from "./MonthlyScoresFilteredByWriterViewModel";

export const studentProgressReportApiSlice = siteApiSlice.injectEndpoints({
	endpoints: (build) => ({
		studentProgressReport: build.query<
			MonthlyScoresFilteredByWriterViewModel,
			{
				writerId?: number;
				courseId?: number;
				beginSchoolYear?: number;
				endSchoolYear?: number;
				today?: string;
			}
		>({
			query: (arg) => {
				const { writerId, courseId } = arg;
				return {
					url: `/progress-report`,
					params: { writerId, courseId },
				};
			},
			providesTags: ["WritingHistory", "CurrentCourse"],
		}),
	}),
});

export const { useStudentProgressReportQuery } = studentProgressReportApiSlice;
